import { format } from "date-fns";
import CardLayout from "../common/CardLayout";
import Table from "../common/table";

import TitleCard from "../common/TitleCard";

export default function UltimasLeiturasAdicionadas({ultimasLeituras}) {

    return <CardLayout>
        <TitleCard>Últimas Leituras Adicionadas</TitleCard>
        <Table.Root>
            <Table.Head>
                    <Table.Header>
                        Produto
                    </Table.Header>
                    <Table.Header>
                        Ambiente
                    </Table.Header>
                    <Table.Header>
                        Data hora
                    </Table.Header>
                    <Table.Header>
                        Temperatura
                    </Table.Header>
                    <Table.Header>
                        Tempo de retenção
                    </Table.Header>
            </Table.Head>
            <Table.Body>
                {
                    ultimasLeituras.map((leitura, i) => (
                        <Table.Row key={i}>
                            <Table.Data>
                                {leitura.nomeProduto}
                            </Table.Data>
                            <Table.Data>
                                {leitura.nomeAmbiente}
                            </Table.Data>
                            <Table.Data>
                                {format(leitura.dataHora, "dd/MM/yyyy HH:mm")}
                            </Table.Data>
                            <Table.Data>
                                {
                                    leitura.temperatura.toLocaleString('pt-BR', {
                                        maximumFractionDigits: 2,
                                })
                                }
                            </Table.Data>
                            <Table.Data>
                                {
                                    leitura.tempoRetencao.toLocaleString('pt-BR', {
                                        maximumFractionDigits: 2,
                                    })
                                }
                            </Table.Data>
                        </Table.Row>
                    ))
                }
 
            </Table.Body>
        </Table.Root>
    </CardLayout>
}